!function(){
  "use strict";

  const t = "[data-ticker-scale]",
        e = "[data-ticker-text]",
        i = "data-clone",
        s = "autoplay",
        c = "speed",
        h = "ticker--animated",
        r = "ticker--unloaded",
        a = "ticker__comparitor",
        o = 1.63,
        n = 100;

  customElements.get("ticker-bar") || customElements.define("ticker-bar", class extends HTMLElement {
    constructor() {
      super();

      this.autoplay = this.hasAttribute(s);
      this.isScrollTriggered = this.classList.contains("scroll-triggered");

      this.scale = this.querySelector(t);
      this.text = this.querySelector(e);
      this.speed = this.hasAttribute(c) ? this.getAttribute(c) : o;

      this.comparitor = this.text.cloneNode(true);
      this.comparitor.classList.add(a);
      this.appendChild(this.comparitor);

      this.scale.classList.remove(r);
      this.checkWidthEvent = this.checkWidth.bind(this);
    }

    connectedCallback() {
      if (this.isScrollTriggered) return; // ⛔ Skip all ticker logic for scroll-triggered mode

      this.checkWidth();
      this.addEventListener("theme:ticker:refresh", window.theme.debounce(() => this.checkWidthEvent(), 50));
      screen.orientation.addEventListener("change", this.checkWidthEvent);
      document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }

    disconnectedCallback() {
      if (this.isScrollTriggered) return;
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }

    checkWidth() {
      this.text = this.querySelector(e);
      const padding = 2 * parseFloat(window.getComputedStyle(this).paddingLeft.replace("px", ""));
      const needsClone = this.clientWidth - padding < this.comparitor.clientWidth;

      if (needsClone || this.autoplay) {
        this.text.classList.remove(h);

        // Remove previous clones
        const clones = this.scale.querySelectorAll(`[${i}]`);
        clones?.forEach(clone => clone.remove());

        const repeatCount = this.autoplay
          ? parseInt((window.innerWidth - padding) / this.text.clientWidth)
          : 2;

        if (this.autoplay || needsClone) {
          for (let j = 0; j <= repeatCount; j++) {
            const clone = this.text.cloneNode(true);
            clone.setAttribute(i, "");
            this.scale.appendChild(clone);
          }
        }

        const animationTime = (this.text.clientWidth / n * Number(this.speed)).toFixed(2);
        this.scale.style.removeProperty("--animation-time");
        this.scale.style.setProperty("--animation-time", `${animationTime}s`);

        this.scale.querySelectorAll(e)?.forEach(el => {
          el.classList.add(h);
        });
      } else {
        this.text.classList.add(h);
        this.scale.querySelectorAll(`[${i}]`).forEach(clone => clone.remove());
        this.text.classList.remove(h);
      }
    }
  });
}();
